import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import './LanguageModal.css';

const LanguageModal = () => {
  const { showModal, selectLanguage } = useLanguage();

  if (!showModal) return null;

  return (
    <>
      <div className="language-modal-overlay"></div>
      <div className="language-modal">
        <div className="language-modal-content">
          <h2 className="language-modal-title">
            {translations.es.languageModal.title}
          </h2>
          <p className="language-modal-subtitle">
            {translations.en.languageModal.title}
          </p>
          
          <div className="language-buttons">
            <button 
              onClick={() => selectLanguage('es')} 
              className="language-button"
              aria-label="Seleccionar Español"
            >
              <span className="language-code">ES</span>
              <span className="language-name">Español</span>
            </button>
            
            <button 
              onClick={() => selectLanguage('en')} 
              className="language-button"
              aria-label="Select English"
            >
              <span className="language-code">EN</span>
              <span className="language-name">English</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LanguageModal;
